<template>
    <!-- 热点新闻 -->
    <div class="home-region hot-news">
        <div class="region-cont">
            <div class="tit tit-blue">热点新闻 <div class="tit-bottom"></div></div>
            <div class="hot-news-info" v-loading='newsLoading'>
                <div class="info-carousel">
                    <el-carousel indicator-position='none' @change='newsCarousel' :interval="50000" arrow="always"  height='384px'>
                        <el-carousel-item v-for="(item,index) in newsList" :key="index">
                            <div class="carousel-cont">
                                <a href="javascript:;" @click.prevent="toPage('hotNewsDetails',item)">
                                   <el-image 
                                    :src="item.cover"
                                    fit="cover">
                                    </el-image>
                                    <!-- <img width="100%" height="100%" :src="item.pic" alt=""> -->
                                </a>
                                <p class="carousel-tit">{{item.title}}</p>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                    <p class="page-num">{{newsIndex}}/4</p>
                </div>
                <div class="info-news">
                    <div class="new-nav">
                        <ul class="nav-list">
                            <li v-for="(item,index) in newsNav" :class="navIndex==index?'active':''" :key="index" @click="nav_tab(item,index)">
                                <p class="nav-val">{{item.tabVal}}</p> 
                                <p class="nav-line"></p>
                            </li>
                        </ul>
                        <div class="news-more" @click="toPage('hotNewsList')"> 查看更多<i class="el-icon-d-arrow-right"></i> </div>
                    </div>
                    <ul class="news-list" > 
                        <li class="list" v-for="(item,index) in newsList" :key="index">
                            <div @click="toPage('hotNewsDetails',item)">
                                <p class="list-tit">{{item.title}}</p>
                                <p v-if='item.info' class="list-info">{{item.info}}</p>
                                <p class="list-timer" ><i class="el-icon-time" v-if="item.publishDate"></i> {{item.publishDate}}</p>
                            </div>
                        </li> 
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import homeData from '../homeData.js';
import {hotNewsList} from '../../../io/api.js';
export default {
    data () {
        return {
            newsLoading:false,
            newsIndex:1,
            newsNav:homeData.newsNav,
            navIndex:0,
            //newsCarouselList:[],//homeData.newsCarouselList,
            newsList:[],//homeData.newsNav[0].infoList,
        }
    },
    mounted(){
        this.getHotNewsList('热点新闻');
    },
    methods: {
        newsCarousel(val){ 
            this.newsIndex=Number(val)+1;
        },
        nav_tab(item,index){
            this.navIndex=index; 
            let type = item.tabVal=='一周热点'?'热点新闻':'热门资讯';
            this.getHotNewsList(type);
        },
        getHotNewsList(type){
            this.newsLoading=true;
            let params = {
                newsType:type,
                page:1,
                limit:4
            }
            hotNewsList(params).then(res=>{
                let {code,data,msg} = res.data;
                if(code==0){
                    this.newsList=data.list||[];
                }else{
                    this.$message.error(msg||'请求失败～')
                }
                this.newsLoading=false;
            })
        },
        toPage(path,item){
            let query={
                changeflag: 5
            }
            if(item){
                query.id=item.id;
            } 
            let url = this.$router.resolve({
                path: path, 
                query
            })
            this.$windowOpen({ url:url.href,isLogin:false} )
            // this.$router.push({
            //     path: path, 
            //     query: {
            //         id: item.id,
            //         changeflag: item.changeflag||5
            //     }
            // })
        }
    }
}
</script>

<style lang="less" scoped>
//热点新闻
.hot-news{
    .flex-space-between{
        display: flex;
        justify-content: space-between;
    }
    .hot-news-info{
        .flex-space-between();
    
        .info-carousel{
            width: 660px;
            height: 384px; 
            position: relative;
            color: #FFFFFF;
            img{

                border-radius: 8px;
                overflow: hidden;
            }
            ::v-deep .el-carousel__arrow {
                /* 你的样式 */ 
                position: absolute;
                top:346px;
                border: 1px solid #e8e8e8;
                width: 28px;
                height: 28px;
            }
                
            ::v-deep .el-carousel__arrow--left {

                left: 520px; /* 示例：改变左边箭头的位置 */
            }
                
            ::v-deep .el-carousel__arrow--right {
                right: 20px; /* 示例：改变右边箭头的位置 */
            }
            .carousel-cont{
                height: 384px;
                position: relative;
                background: #F3F3F5;
                ::v-deep .el-image{
                    width: 100%;
                    height: 100%;
                }
                .carousel-tit{
                    position: absolute;
                    bottom:24px;
                    left:20px;
                    width: 424px;
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 22px;
                    .txt-overflow();
                }
            }
            .page-num{
                position: absolute;
                top:328px;
                right: 50px;
                z-index: 10;
                width: 60px;
                text-align: center;
                line-height:36px; 
                font-size: 16px;
                font-weight: bold;
            }
        }
        .info-news{
            width: 500px;
            .new-nav{
                .flex-space-between();
                height: 40px;
                border-bottom: 1px solid #C0D9F6;
                width: 500px;
            }
            .nav-list{
                display: flex;
                width: 400px;
                li{
                    margin-right: 40px;
                    line-height: 20px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333; 
                    cursor: pointer;
                    &.active{
                        .nav-val{
                            font-weight: bold;
                        }
                        .nav-line{
                            width: 100%;
                            height: 4px;
                            background: #0C55AA;
                        }
                    }
                    .nav-val{
                        height: 20px;
                        margin-bottom: 16px;
                    }
                    
                }
            }
            .news-more{
                width: 80px; 
                cursor: pointer;
                font-weight: 400;
                font-size: 12px;
                color: #386DE8;
            }
        } 
        .news-list{
            height: 340px;
            padding :10px 0 0 20px;
            .list{
                padding:16px 0;
                border-bottom: 1px solid #E9EFF6;
                line-height: 16px;
                // &:first-child{
                //     .list-tit{ 
                //         text-align: center;
                //     }
                //     .list-info{ 
                //         overflow : hidden;
                //         text-overflow: ellipsis;
                //         display: -webkit-box;
                //         display: -webkit-box;
                //         -webkit-line-clamp: 2;//（文字行数）;;
                //         -webkit-box-orient: vertical;  
                //         font-weight: 400;
                //         font-size: 12px; 
                //         cursor: pointer;
                //         color: #999999;
                //     }
                // }
                .list-tit{
                    font-weight: bold;
                    font-size: 14px;
                    color: #333333;
                    line-height: 20px;
                    margin-bottom: 16px;
                    cursor: pointer;
                    .txt-overflow();
                }
                .list-timer{ 
                    font-weight: 400;
                    font-size: 12px;
                    color: #B2B2B2;
                    height: 16px;
                }
                
            }
        } 
    }
    .txt-overflow{
        white-space:nowrap;//(文字不换行);
        overflow:hidden;//( 溢出隐藏);
        text-overflow:ellipsis;//( 文本有溢出加省略号 );
    }
}
</style>